const RequiredIndicatorLabelComponent = {
    templateUrl: '/formViewer/component/requiredIndicatorLabel/requiredIndicatorLabel.tpl.html',
    controller: 'requiredIndicatorLabelController',
    bindings: {
        config: '<requiredLabelConfig'
    }
};

angular.module('umFormViewer')
    .component('uiRequiredIndicatorLabel', RequiredIndicatorLabelComponent);
